'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useCurrentStore } from '../../utils/use-store-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface LandingPageHeadingProps {
  badge: string;
  title: string;
  as?: 'h1' | 'h2' | 'h3';
  className?: {
    container?: string;
    title?: string;
    badge?: string;
  };
}

export function LandingPageHeading({
  badge,
  title,
  className,
  as = 'h3',
}: LandingPageHeadingProps) {
  const { isGasGas, isCFMoto } = useCurrentStore();

  return (
    <div
      className={cn('flex w-full flex-col items-start justify-start gap-2.5', className?.container)}
    >
      <span
        className={cn(
          'bg-primary px-3 py-0.5 text-xs font-semibold tracking-tighter text-black',
          isGasGas && 'text-white',
          isCFMoto && 'text-white',
          className?.badge,
        )}
      >
        {badge}
      </span>
      <HtmlRendererRaw
        as={as}
        className={cn(
          'ea-landing-page__heading-title',
          'text-[28px] font-medium tracking-tighter text-black sm:text-3xl md:text-4xl lg:text-5xl lg:leading-tight',
          className?.title,
        )}
        html={title}
      />
    </div>
  );
}
